import forge from './forge';

// Vault DB types — field names match postgres snake_case column names
export interface VaultRequest {
	id: string;
	method: string;
	userId: string;
	params: Record<string, any>;
	createdAt: string;
}

export interface RequestLog {
	id: number;
	label: string;
	type: string;
	value: string;
	createdAt: string;
}

interface GetRequestsResponse {
	requests: VaultRequest[];
}

interface GetRequestLogsResponse {
	logs: RequestLog[];
}

export async function getRequests(params: {
	filter?: string;
	count?: number;
	startDate?: string;
	endDate?: string;
}): Promise<VaultRequest[]> {
	const { data } = await forge.get<GetRequestsResponse>('/api/vault/requests', { params });
	return data.requests;
}

export async function getRequestLogs(requestId: string): Promise<RequestLog[]> {
	const { data } = await forge.get<GetRequestLogsResponse>(
		`/api/vault/requests/${requestId}/logs`
	);
	return data.logs;
}
